export enum GlobalTextStyling {
  UpperCase = 'uppercase',
  LowerCase = 'lowercase',
  Capitalize = 'capitalize',
  Bold = 'bold',
  Italic = 'italic',
  LetterSpacing1 = 'spaced-1',
  LetterSpacing2 = 'spaced-2',
}
